import { BrowserType } from '../../Enums/ChoiceEnums';

export function getScreenSize() : IScreenSizeModel | undefined
{
    if (screen?.width) {
        return {width: screen.width, height: screen.height};
    }
}

export function getBrowser(): IBrowserAndVersion
{
    //browser
    const nAgt = navigator.userAgent;    
    let version: string = "";
    let browser = getBrowserType().toString();

    switch(browser)
    {
        case BrowserType.Opera:
            {
                let verOffset = nAgt.indexOf('Opera');
                version = nAgt.substring(verOffset + 6);
                if ((verOffset = nAgt.indexOf('Version')) != -1)
                    version = nAgt.substring(verOffset + 8);    
            }
            break;
            
        case BrowserType.MSIE:
            version = "???";
            break;

        case BrowserType.Edge:
            version = nAgt.split(" Edge/")[1].split(" ")[0]; 
            break;

        case BrowserType.Chrome:
            {
                const verOffset = nAgt.indexOf('Chrome');
                version = nAgt.substring(verOffset + 7);
            }
            break;

        case BrowserType.Safari:
            {
                let verOffset = nAgt.indexOf('Safari');
                version = nAgt.substring(verOffset + 7);
                if ((verOffset = nAgt.indexOf('Version')) != -1)
                    version = nAgt.substring(verOffset + 8);                        
            }
            break;

        case BrowserType.Firefox:
            {
                const verOffset = nAgt.indexOf('Firefox')
                version = nAgt.substring(verOffset + 8);
            }
            break;

        case BrowserType.Trident:
            version = nAgt.substring(nAgt.indexOf('rv:') + 3);
            break;

        case BrowserType.Other:
            {
                const nameOffset = nAgt.lastIndexOf(' ') + 1;
                const verOffset = nAgt.lastIndexOf('/');
                browser = nAgt.substring(nameOffset, verOffset);
                version = nAgt.substring(verOffset + 1);
                if (browser.toLowerCase() == browser.toUpperCase())
                    browser = navigator.appName;
            }
            break;
    }

    // trim the version string
    version = version.trim();

    const appVersion = navigator.appVersion;    
    let majorVersion = parseInt('' + version, 10);
    if (isNaN(majorVersion)) {
        version = '' + parseFloat(appVersion);
        majorVersion = parseInt(appVersion, 10);
    }    

    // mobile version
    const mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(appVersion);

    return { 
        name: browser,
        majorVersion: majorVersion,
        fullVersion: version,
        mobile: mobile
    };
}

function getBrowserType(): BrowserType
{
    const nAgt = navigator.userAgent;

    // Opera
    if (nAgt.indexOf('Opera') != -1) 
        return BrowserType.Opera;
    
    // MSIE
    if (nAgt.indexOf('MSIE') != -1) 
        return BrowserType.MSIE;
    
    // Edge
    if (nAgt.indexOf('Edge') != -1) 
        return BrowserType.Edge;

    // Chrome
    if (nAgt.indexOf('Chrome') != -1) 
        return BrowserType.Chrome;
    
    // Safari
    if (nAgt.indexOf('Safari') != -1) 
        return BrowserType.Safari;

    // Firefox
    if (nAgt.indexOf('Firefox') != -1) 
        return BrowserType.Firefox;
    
    // MSIE 11+
    if (nAgt.indexOf('Trident/') != -1) 
        return BrowserType.Trident;
    
    // Other browsers
    return BrowserType.Other;
}

export function isCookieEnabled(): boolean {
    return navigator.cookieEnabled;
}

export function getOperatingSystemInfo() : IOperatingSystem
{
    // system
    const unknown = "-";
    let os = unknown;
    const clientStrings = [
        {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
        {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
        {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
        {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
        {s:'Windows Vista', r:/Windows NT 6.0/},
        {s:'Windows Server 2003', r:/Windows NT 5.2/},
        {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
        {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
        {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
        {s:'Windows 98', r:/(Windows 98|Win98)/},
        {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
        {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
        {s:'Windows CE', r:/Windows CE/},
        {s:'Windows 3.11', r:/Win16/},
        {s:'Android', r:/Android/},
        {s:'Open BSD', r:/OpenBSD/},
        {s:'Sun OS', r:/SunOS/},
        {s:'Linux', r:/(Linux|X11)/},
        {s:'iOS', r:/(iPhone|iPad|iPod)/},
        {s:'Mac OS X', r:/Mac OS X/},
        {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
        {s:'QNX', r:/QNX/},
        {s:'UNIX', r:/UNIX/},
        {s:'BeOS', r:/BeOS/},
        {s:'OS/2', r:/OS\/2/},
        {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
    ];

    const nAgt = navigator.userAgent;    
    for (const id in clientStrings) {
        const cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
        os = cs.s;
        break;
        }
    }

    let osVersion = unknown;

    if (/Windows/.test(os)) {
        osVersion = (/Windows (.*)/.exec(os) ?? ["", ""])[1];
        os = 'Windows';
    }

    switch (os) {
        case 'Mac OS X':
			try {
				osVersion = (/Mac OS X (10[._\d]+)/.exec(nAgt) ?? ["", ""])[1];
			} catch (e) {
				try {
					osVersion = (/Mac OS X (11[._\d]+)/.exec(nAgt) ?? ["", ""])[1];
				} catch (e) {
					osVersion = "Mac OS X Uknown";
				}
			}
			break;

        case 'Android':
        osVersion = (/Android ([._\d]+)/.exec(nAgt) ?? ["", ""])[1];
        break;

        case 'iOS':
        const nVer = navigator.appVersion;
        const versionInfo = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
        if (versionInfo)
        {
            const majorVer = versionInfo.length > 1 ? versionInfo[1] : "--";
            const minorVer = versionInfo.length > 2 ? versionInfo[2] : "--";
            const buildVer = versionInfo.length > 3 ? versionInfo[3] : "--";

            osVersion = `${majorVer}.${minorVer}.${buildVer}`;
        }
        break;
    }

    return {os, version: osVersion };
}

// Get the info used to share system into at login
export function getSystemInfoForLogin(): ILoginSystemInfoModel
{
    const screen = getScreenSize();
    const browser = getBrowser();
    const os = getOperatingSystemInfo();

    return {
        screenSize: `${screen?.width ?? "???"} x ${screen?.height ?? "???"}`,
        browser: browser.name,
        browserVersion: ""+browser.majorVersion,
        mobile: browser.mobile,
        os: os.os,
        osVersion: os.version,
        cookieEnabled: isCookieEnabled()
    };
}

export interface IScreenSizeModel {
    width: number
    height: number
}

export interface IBrowserAndVersion
{
    name: string,
    majorVersion?: number,
    fullVersion?: string,
    mobile?: boolean
}

export interface IOperatingSystem
{
    os?: string,
    version?: string
}

export interface ILoginSystemInfoModel
{
    screenSize?: string,
    browser?: string,
    browserVersion?: string
    mobile?: boolean,
    os?: string,
    osVersion?: string,
    cookieEnabled?: boolean
}